import http from './http';

// Endpoint map for the new registration page.
// Base: /api/landing-page/{pathname}/registration/*  (session-based, web group)
const base = (pathname) => `/api/landing-page/${pathname}/registration`;

const registrationAPI = {
  // Bootstrap: event meta + CE info + settings + ticket catalog + basket state.
  bootstrap: (pathname, params) => http.get(base(pathname), params),

  // Basket (ticket/addon quantities + donation).
  updateBasket: (pathname, data) => http.put(`${base(pathname)}/basket`, data),
  clearBasket: (pathname) => http.delete(`${base(pathname)}/basket`),

  // Attendees (JSON form schema + values).
  fetchAttendees: (pathname) => http.get(`${base(pathname)}/attendees`),
  updateAttendees: (pathname, data) => http.put(`${base(pathname)}/attendees`, data),

  // Discounts.
  checkField: (pathname, data) => http.put(`${base(pathname)}/attendees/check-field`, data),
  checkMembershipEmail: (pathname, data) => http.put(`${base(pathname)}/attendees/membership-email`, data),
  applyCoupon: (pathname, data) => http.post(`${base(pathname)}/coupons`, data),

  // Sessions step (agenda groups).
  fetchSessions: (pathname) => http.get(`${base(pathname)}/sessions`),
  updateSessions: (pathname, data) => http.put(`${base(pathname)}/sessions`, data),

  // Payment.
  preparePayment: (pathname, data) => http.post(`${base(pathname)}/payment/prepare`, data),
  confirmPayment: (pathname, params) => http.get(`${base(pathname)}/payment/confirm`, params),

  // Full agenda modal (existing new-theme endpoint, reused).
  fetchAgenda: (pathname) => http.get(`/api/landing-page/${pathname}/event/agenda`),

  // Faculty roster (existing new-theme endpoint, reused) — bios and the
  // sessions each presenter leads, for the presenter detail drawer.
  fetchFaculty: (pathname) => http.get(`/api/landing-page/${pathname}/event/faculty`),
};

export default registrationAPI;
